<div class="log" *ngIf="show.log">
  <app-kontablenew
  title = "{{'voucherCouponsMg.title_Log' | translate}}"
  id="webLog_Log_Table"
  [columns] = "[
  { field: 'dateTime', title: 'voucherCouponsMg.dt_weblog_weblog_date', bodyTemplate: dateTimeTemplate, sortable: false },
  { field: 'storeId', title: 'voucherCouponsMg.dt_weblog_log_store', sortable:false },
  { field: 'terminalId', title: 'voucherCouponsMg.dt_weblog_log_terminal', sortable:false },
  { field: 'stateCode', title: 'voucherCouponsMg.dt_weblog_log_status', sortable:false },
  { field: 'stateDescription', title: 'voucherCouponsMg.dt_weblog_log_idstate', sortable:false },
  { field: 'kpayTransactionId', title: 'voucherCouponsMg.dt_weblog_log_transaction', sortable:false }
]"
[paginationType]="paginationType_Log"
[showInfoButton]="false"
[showGlobalFilter]="false"
[showReport]="false"
[showDetailsButton]="false"
[showAddButton]="false"
[showEditButton]="false"
[showDeleteButton]="false"
[fixedFilters]="initialFilters.log"
[showResetFiltersBtn]="false"
[service]="srvVoucherCoupon"
[methodsNames]="methodsNames.log"
[columnFiltersEnabled]="false"
[showRowButtons]="false"
#WebLog_Log>

  <ng-template #dateTimeTemplate data-testid="dateTimeTemplate" let-row>
    <span>{{getDateTime(row.dateTime)}}</span>
  </ng-template>

</app-kontablenew>
</div>
<br />


<div class="weblog" *ngIf="show.webLog">
  <app-kontablenew
  title = "{{'voucherCouponsMg.title_WebLog' | translate}}"
  id="webLog_webLog_Table"
  [columns] = "[
  { field: 'dateTime', title: 'voucherCouponsMg.dt_weblog_weblog_date', bodyTemplate: dateTimeTemplate, sortable: false },
  { field: 'userDescription', title: 'voucherCouponsMg.dt_weblog_weblog_user', sortable:false },
  { field: 'ip', title: 'voucherCouponsMg.dt_weblog_weblog_ip', sortable:false },
  { field: 'printed', title: 'voucherCouponsMg.dt_weblog_weblog_printed', bodyTemplate: printedTemplate, sortable: false },
  { field: 'stateDescription', title: 'voucherCouponsMg.dt_weblog_weblog_status', sortable:false }
]"
[paginationType]="paginationType_WebLog"
[showGlobalFilter]="false"
[showReport]="false"
[showAddButton]="false"
[fixedFilters]="initialFilters.webLog"
[service]="srvVoucherCoupon"
[methodsNames]="methodsNames.webLog"
[columnFiltersEnabled]="false"
[showResetFiltersBtn]="false"
[showRowButtons]="false"
#WebLog_Log>


<ng-template #dateTimeTemplate data-testid="dateTimeTemplate" let-row>
  <span>{{getDateTime(row.dateTime)}}</span>
</ng-template>

<ng-template #printedTemplate data-testid="printedTemplate" let-row>
  <span *ngIf="row.printed === true">{{'common.yes' | translate}}</span>
  <span *ngIf="row.printed === false">{{'common.no' | translate}}</span>
</ng-template>

</app-kontablenew>
</div>



// WEBPACK FOOTER //
// ./src/app/views/voucher-coupon-mg/voucher-coupon-mg-detail/web-log/web-log.component.html